<button class="btn btn-shadow-primary quantity-price-cart-btn ws-cart-button {{sizeCssClass}}"
        [id]="'cart-button-toggler'"
        (click)="onClick()">
  <div class="cart-quantity">
    <i class="icon-cart"></i>
    <span>{{quantity}}</span>
  </div>

  <div>
    {{totalPrice | currencyFormat: currency}}
  </div>
</button>
